import { StoreMappingDetailPage } from "@/features/store-mapping/pages/StoreMappingDetailPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/store-mapping/$id/detail")({
	component: RouteComponent,
});

function RouteComponent() {
	const { id } = Route.useParams();
	return <StoreMappingDetailPage id={id} />;
}

